<div cdkDrag cdkDragRootElement=".cdk-overlay-pane"
     class="modal-header-title {{ showCoverPhoto? 'no-bg' : ''}}">
    <div cdkDragHandle class="title">
      {{title | translate}}
      <div class="handle"></div>
      <span class="close-modal" mat-dialog-close>
          <mat-icon>close</mat-icon>
      </span>
    </div>

</div>
